/** Which layers this person has pinned down. Session state: kept for the tab, never stored. */

import type { Locks } from "../LayersPanel";

const PREFIX = "nebulize.editor.locks.";

function keyOf(spaceId: string): string {
  return `${PREFIX}${spaceId}`;
}

/** What this tab remembers about locks for one space, or nothing when it remembers nothing. */
export function readLocks(spaceId: string): Locks {
  try {
    const raw = window.sessionStorage.getItem(keyOf(spaceId));
    if (raw === null) return {};
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null) return {};
    return parsed as Locks;
  } catch {
    return {};
  }
}

/** Session storage can be unavailable (private mode, quota); a lock then just stays in memory. */
export function writeLocks(spaceId: string, locks: Locks): void {
  try {
    window.sessionStorage.setItem(keyOf(spaceId), JSON.stringify(locks));
  } catch {
    // Nothing to fall back to here: the caller's own state is already the truth for this render.
  }
}
